export const TIMER_INTERVAL = 1000;

export const ROTATION_INTERVAL = 30000;

export const MAX_TITLE_LENGTH = 150;
